export default function Status(status: string) {
  const statusClass = () => {
    if (["ongoing", "available"].includes(status))
      return "rounded-2xl bg-orange-400 text-white w-24 text-center capitalize";
    else if (status === "completed")
      return "rounded-2xl bg-green-400 text-white w-24 text-center capitalize";
    else if (status === "cancelled")
      return "rounded-2xl bg-red-400 text-white w-24 text-center capitalize";
  };

  return (
    <p
      style={{ paddingBottom: "2px", fontSize: "13px" }}
      className={statusClass()}
    >
      {status}
    </p>
  );
}
